import { render, staticRenderFns } from "./Man.vue?vue&type=template&id=4e0b8d69&"
import script from "./Man.vue?vue&type=script&lang=ts&"
export * from "./Man.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports